const PositionAddress = async ({
  // loader,
  google,
  address = "",
  isAllResponse = false,
}) => {
  // const google = await loader.load();
  const geocoder = new google.maps.Geocoder();

  try {
    const response = await geocoder.geocode({ address });
    // console.log("response =>", response);

    if (isAllResponse) {
      return response;
    }

    if (response.results[0]) {
      const locationRef = response.results[0]?.geometry?.location;
      const location = {
        lat: locationRef.lat(),
        long: locationRef.lng(),
      };
      // console.log("location =>", location);
      return location;
    } else {
      // console.log("No results found");
      // window.alert("No results found");
      return {
        error: {
          message: `No results found`,
        },
      };
    }
  } catch (err) {
    // console.log("Geocoder error =>: ", err);
    return {
      error: {
        message: `Geocoder failed due to: ${err.message}`,
      },
    };
  }
};

export default PositionAddress;
